const RateConversationActionTypes = {
    CLEAR_CONVERSATION_STATUS: 'CLEAR_CONVERSATION_STATUS',
    SET_CONVERSATION_STATUS: 'SET_CONVERSATION_STATUS',
    SET_RATE_CONVERSATION_OPEN: 'SET_RATE_CONVERSATION_OPEN',
    SET_RATE: 'SET_RATE',
    SET_RATE_HOVER: 'SET_RATE_HOVER',
    SET_HOST_NAME: 'SET_HOST_NAME',
};
export default RateConversationActionTypes;
